var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row head" }),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row setting row-first",
        class: { "setting--nb": _vm.$root.app.platform == "android" }
      },
      [
        _vm.$root.app.platform == "android"
          ? _c("div", { staticClass: "col col-100" }, [
              _c("span", { staticClass: "row__title" }, [_vm._v("Onderwerp")]),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "select-wrap" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.subject,
                      expression: "form.subject"
                    }
                  ],
                  attrs: {
                    type: "text",
                    name: "subject",
                    placeholder: "Stel je vraag"
                  },
                  domProps: { value: _vm.form.subject },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "subject", $event.target.value)
                      },
                      function($event) {
                        return _vm.$v.form.subject.$touch()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "select-arrow" })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c("div", { staticClass: "col col-50" }, [
              _c("span", { staticClass: "row__title" }, [_vm._v("Onderwerp")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c("div", { staticClass: "col col-50" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.subject,
                    expression: "form.subject"
                  }
                ],
                attrs: {
                  type: "text",
                  name: "subject",
                  placeholder: "Stel je vraag"
                },
                domProps: { value: _vm.form.subject },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "subject", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.form.subject.$touch()
                    }
                  ]
                }
              })
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row row-last setting" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c(
          "div",
          {
            staticClass: "form-group",
            class: { "form-group--error": _vm.$v.form.message.$error }
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.message,
                  expression: "form.message"
                }
              ],
              staticClass: "form__input form__textarea",
              attrs: { type: "text", placeholder: "Typ hier je bericht" },
              domProps: { value: _vm.form.message },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "message", $event.target.value)
                  },
                  function($event) {
                    return _vm.$v.form.message.$touch()
                  }
                ]
              }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "android"
      ? _c("div", { staticClass: "row row-button" }, [
          _c(
            "div",
            {
              staticClass: "col col-100",
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [
              _c("button", { staticClass: "button" }, [
                _vm._v("Ticket versturen")
              ])
            ]
          ),
          _vm._v(" "),
          !_vm.$v.form.message.required
            ? _c("span", { staticClass: "form-group__message" }, [
                _vm._v("Veld is verplicht")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.message.minLength
            ? _c("span", { staticClass: "form-group__message" }, [
                _vm._v(
                  "Bericht dient minimaal " +
                    _vm._s(_vm.$v.form.message.$params.minLength.min) +
                    " tekens te bevatten."
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row row-last setting" }, [
          _c(
            "div",
            {
              staticClass: "col col-100",
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [
              _c("button", { staticClass: "button" }, [
                _vm._v("Ticket versturen")
              ])
            ]
          ),
          _vm._v(" "),
          !_vm.$v.form.message.required
            ? _c("span", { staticClass: "form-group__message" }, [
                _vm._v("Veld is verplicht")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.message.minLength
            ? _c("span", { staticClass: "form-group__message" }, [
                _vm._v(
                  "Bericht dient minimaal " +
                    _vm._s(_vm.$v.form.message.$params.minLength.min) +
                    " tekens te bevatten."
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b927558", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b927558","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/Create.vue
// module id = null
// module chunks = 